<template>
  <div class="bg-white p-4 rounded-2xl border border-gray-100 flex items-center gap-4">
    <div class="w-12 h-12 rounded-xl border border-gray-100 flex items-center justify-center bg-purple-50 flex-shrink-0">
      <i class="pi pi-microphone text-2xl text-purple-500"></i>
    </div>
    <div class="flex-1 min-w-0 text-right">
      <h3 class="font-bold text-gray-900 text-base">בוט AI אישי</h3>
      <p class="text-xs text-gray-500 leading-snug mt-0.5">עוזר קולי ובטקסט לניהול העסק שלך</p>
    </div>
    <InputSwitch
      :modelValue="isEnabled"
      :disabled="loading"
      @update:modelValue="onToggle"
    />
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue';
import { useToast } from 'vue-toastification';
import { useAdminStore } from '@app/stores';
import { SettingsApi } from '@app/api/admin';
import { trackEvent } from '@app/composables/posthog';

const adminStore = useAdminStore();
const toast = useToast();

const loading = ref(false);
const isEnabled = computed(() => adminStore.getBusinessSiteData?.configurations?.adminAiEnabled !== false);

const onToggle = async (enabled: boolean) => {
  trackEvent('admin_ai_toggled', { enabled });
  loading.value = true;
  try {
    await SettingsApi.toggleAdminAi(enabled);
    await adminStore.fetchBusinessData();
    toast.success(enabled ? 'בוט AI הופעל' : 'בוט AI כובה');
  } catch {
    toast.error('שגיאה בשינוי הגדרת AI');
  } finally {
    loading.value = false;
  }
};
</script>
